// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3qFHL","title":"Images45_title__2KXfA","images":"Images45_images__2mIiw"};